<template>
    <modal-dialog
        ref="modalDialog"
        :confirmBtnTxt="'Yes'"
        :isLoading="isLoading"
        @confirm-dialog="save()"
        @close="clear"
    >
        <template v-slot:title> Switch to {{ business.name }} </template>
        <template v-slot:body>
            {{ message }}
        </template>
    </modal-dialog>
</template>
<script>
import ModalDialog from "@/components/commons/modal-dialog";

export default {
    components: {
        ModalDialog
    },
    data() {
        return {
            isLoading: false,
            business: { name: "" },
            message: "",
            isSwitch: false
        };
    },
    methods: {
        async open(data) {
            this.message = data.message;
            this.business = data.switch_business;
            const response = await $.getJSON(
                process.env.APPS + "index.php/ajax/business/checkAccess",
                { business_id: data.switch_business.id }
            );
            if (response.allowed) {
                //check if user have access to switch business
                this.$refs.modalDialog.open();
            } else {
                this._message("Access to this link is restricted.", "danger");
                this.$emit("redirect-to-dashboard");
                this.close();
            }
        },
        close() {
            this.clear();
            this.$refs.modalDialog.close();
        },
        async save() {
            this.isSwitch = true;
            this.isLoading = true;
            const response = await $.getJSON(
                process.env.APPS + "index.php/ajax/business/checkAccess",
                { business_id: this.business.id }
            );
            if (response) {
                if (response.allowed) {
                    localStorage.removeItem("sf_username");
                    localStorage.removeItem("my_staff_url");
                    localStorage.setItem("Vetter-Token", response.token);

                    let res = await this.$http.get(
                        process.env.APPS +
                            "index.php/business/business/switch_instance?bid=" +
                            this.business.id +
                            "&redirect=0" // redirect = 0 tells the server to not use redirect (on the server side). let the client side handle the redirection
                    );

                    if (res?.data?.success) {
                        this.$socket.client.emit("v-broadcast-all", {
                            businessId: this.$root.setting.business_id,
                            userId: this.$root.currentActor.id,
                            action: "post-switch-instance",
                            url: window.location.href,
                            isAutomation: res?.data?.is_automation,
                            instance: localStorage.getItem("instance")
                        });
                    }
                } else {
                    this._message(response.message, "danger");
                    this.$emit("redirect-to-dashboard");
                }
            }
            this.isLoading = false;
            this.close();
        },
        clear() {
            this.message = "";
            this.business = { name: "" };
            this.isLoading = false;
            if (!this.isSwitch) {
                this.$emit("redirect-to-dashboard");
            }
        }
    }
};
</script>
